export default class AccordionItem {
    public id: string;
    public title: string;
    public content: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.content = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/accordionItemEntity.ts